<template>
  <div class="list-wrapper receive-returns">
    <div class="content-wrapper">
      <div class="h-full">
        <div class="c_group">
          <query-form
            class="content_block"
            label-width="116px"
            size="small"
            label-position="right"
            @search="getList('init')"
            @reset="handleReset"
            :keepOpenedRow="2">
            <el-form-item label="退货状态" :span="24" label-width="80px">
              <check-tag
                v-model="advancedForm.receiveStatus"
                @change="() => getList('init')"
              >
                <check-tag-item
                  :value="i.value"
                  :key="i.value"
                  v-for="i in executionStatusGroup"
                  :label="`${i.label}(${i.count || 0})`"
                ></check-tag-item>
              </check-tag>
            </el-form-item>
            <el-form-item label="销售单号" label-width="80px">
              <el-input
                v-model.trim="advancedForm.orderCode"
                clearable
                placeholder="请输入销售单号"
              ></el-input>
            </el-form-item>
            <el-form-item label="退货申请单号">
              <el-input
                v-model.trim="advancedForm.outRefundCode"
                clearable
                placeholder="请输入退货申请单号"
              ></el-input>
            </el-form-item>
          </query-form>
        </div>
        <div class="table-wrapper" :class="{ 'fullscreen': isFullScreen }">
          <xz-table
            ref="xzTable"
            :columns="columnList"
            :data="dataList"
            rowKey="id"
            :toolsAttrs="toolsAttrs"
            :scroll="{ x: '100%', y: scrollHeight }"
            :isNest="true"
            :expandedRowKeys.sync="expandedRowKeys"
            @openCloseAll="openCloseAll"
            @refresh="handleReset"
            @fullScreen="handleFullScreen"
            @expand="expandRow">
            <template #custom>
              <tableHeaderConfiguration businessType="receiveReturns" :disabledList="disabledList" :baseLists="baseLists" @updateColumnList="updateColumnList"  />
            </template>
            <div slot="action" slot-scope="_, row">
              <a v-if="$withPermission('gongxutong:sale_after:return:detail')" @click="() => operate('detail', row)">查看</a>
              <a v-if="row.receiveStatus === 1 && $withPermission('gongxutong:sale_after:return:sure')" style="margin-left: 8px" @click="() => operate('confirm', row)">确认收货</a>
            </div>
            <template
              slot="expandedRowRender"
              slot-scope="text, rowIndex">
              <div v-if="text.logisticsList && text.logisticsList.length">
                <div v-for="(logostics, index) in text.logisticsList" :key="'logostics-'+index" class="subTable">
                  <div class="logostics-box">
                    <img @click="showOpenSubTable(logostics, index, rowIndex)" :src="logostics.show ? require('@/assets/icon_open.svg') : require('@/assets/icon_close.svg')" class="icon" />
                    <div @click="showOpenSubTable(logostics, index, rowIndex)" class="company">{{ logostics.logisticsCompanyName }}</div>
                    <div class="info">
                      物流单号<span @click="handleShowExpressDialog(logostics)" class="value" style="color: #5195eb;cursor: pointer;">{{ logostics.code }}</span>
                    </div>
                    <div class="info">
                      物流状态<span class="value">{{ logostics.statusDesc || '--' }}</span>
                    </div>
                  </div>
                  <xz-table
                    v-if="logostics.show"
                    :columns="subColumnsLists"
                    :data="logostics.goodsSerialDetailList"
                    rowKey="id"
                    class="subTable"
                    slot="expandedRowRender"
                    style="margin-bottom: 10px;">
                    <template slot="imageList" slot-scope="image">
                      <span v-if="image && image.split(',').length > 0">
                        <span v-for="(img, i) in image.split(',')" :key="'img-'+i">
                          <el-image v-if="i < 2" style="width: 32px; height: 32px; margin-right: 5px;" :src="img" :preview-src-list="image.split(',')" />
                        </span>
                        <span v-if="image.split(',').length > 2" style="color:#3182bd; margin-left: 2px;">...</span>
                      </span>
                      <span v-else>暂无图片</span>
                    </template>
                    <template slot="footer">
                      <div>
                        <b style="margin-right: 100px;">合计</b>
                        <b style="margin-right: 5px;">数量：{{ logostics.totalQuantity }}</b>
                        <b>，总金额：{{ logostics.totalPrice.toLocaleString('en-US', { minimumFractionDigits: 2 }) || '-' }}</b>
                      </div>
                    </template>
                  </xz-table>
                </div>
              </div>
              <div v-else style="margin: 10px; text-align: center;">暂无数据</div>
            </template>
          </xz-table>
        </div>
      </div>
    </div>
    <div class="pagination-wrapper">
      <a-pagination
        :current="pagination.pageNum"
        :total="total"
        :show-total="total => `共 ${total || 0} 条`"
        show-size-changer
        :pageSizeOptions="['10', '20', '30', '50', '100']"
        show-quick-jumper
        :pageSize.sync="pagination.pageSize"
        @change="handleNumChange"
        @showSizeChange="handleSizeChange"
      />
    </div>
    <ExpressDialog ref="expressDialogRef" />
  </div>
</template>
<script>
import xzTable from '@/components/xiaozi-ui/xz-table/src/table.vue';
import tableHeaderConfiguration from '@/components/tableHeaderConfiguration.vue';
import { afterQueryPage, queryStateInfoBySeller, sure } from '@/api/service';
import setTableCols from './configs';
import { executionStatusGroup } from '@/model/serviceReturns';
import ExpressDialog from '@/components/expressDialog.vue';

export default {
  name: 'ServiceReturns',
  components: {
    xzTable,
    tableHeaderConfiguration,
    ExpressDialog,
  },
  computed: {
    toolsAttrs () {
      return {
        refresh: true,
        zoom: true,
        fullScreen: this.isFullScreen,
        // advancedSearch: true,
        custom: true,
      };
    },
  },
  data () {
    return {
      expandedRowKeys: [],
      disabledList: ['code', 'receiveStatus', 'customerName', 'createTime'],
      dataList: [],
      advancedForm: {
        receiveStatus: '',
      },
      executionStatusGroup,
      scrollHeight: 'calc(100vh - 220px - 70px - 110px)',
      columnList: [
        ...setTableCols.call(this),
      ],
      baseLists: [
        ...setTableCols.call(this),
      ],
      subColumnsLists: [
        ...setTableCols.call(this, 'detail2'),
      ],
      isFullScreen: false,
      total: 0,
      pagination: {
        pageNum: 1,
        pageSize: 10,
      },
    };
  },
  created () {
    if (this.$route.query.status || this.$route.query.status === 0) {
      this.advancedForm.receiveStatus = this.$route.query.status + '';
    }

    this.getList();
    this.getCount();
  },
  methods: {
    updateColumnList (columnList) {
      this.columnList = [
        ...columnList,
        {
          title: '操作',
          dataIndex: 'action',
          key: 'action',
          fixed: 'right',
          width: 140,
          scopedSlots: { customRender: 'action' },
        },
      ];
      setTimeout(() => {
        this.expandedRowKeys = [];
        this.$refs.xzTable.addElementsToClass();
      }, 0);
    },
    convertToName (enums, value) {
      let title = '--';

      for (let v of enums) {
        if (Number(v.value) === Number(value)) {
          title = v.label;
          break;
        }
      }

      return title;
    },
    handleFullScreen () {
      this.isFullScreen = !this.isFullScreen;
    },
    handleSizeChange (_, size) {
      this.pagination.pageSize = size;
      this.getList();
    },
    handleNumChange (num) {
      this.pagination.pageNum = num;
      this.getList();
    },
    openCloseAll () {
      setTimeout(() => {
        this.expandedRowKeys.forEach((key) => {
          const elements = document.querySelectorAll(`[data-row-key='${key}-extra-row']`);
          const length = elements.length;
          const height = elements[0].offsetHeight - 19.2;
          const tableContents = elements[0].querySelectorAll('.ant-table-content');
          if (tableContents.length) {
            for (let i = 0; i < tableContents.length; i++) {
              tableContents[i].style.paddingRight = 200 + 'px';
            }
          }

          elements[length - 1].childNodes[0].innerHTML = `<div style='height: ${height}px;'></div>`;

          // 设置fixed-left时，子表格paddingRight为0
          const fixedTableLeft = document.querySelectorAll('.ant-table-fixed-left');
          if (fixedTableLeft.length) {
            const fixedRows = fixedTableLeft[0].querySelectorAll(`[data-row-key='${key}-extra-row']`);
            if (fixedRows.length) {
              const fixedRowsSecondTd = fixedRows[0].querySelectorAll('td')[1];
              if (fixedRowsSecondTd) {
                fixedRowsSecondTd.style.paddingRight = 0;
              }
            }
          }
        });
      }, 0);
    },
    async expandRow (_, rec) {
      this.expandedOneRow(_, rec, 19.2);
    },
    expandedOneRow (_, rec, gap = 0) {
      setTimeout(() => {
        const elements = document.querySelectorAll(`[data-row-key='${rec.id}-extra-row']`);
        const length = elements.length;
        const height = elements[0].offsetHeight - gap;
        const tableContents = elements[0].querySelectorAll('.ant-table-content');

        if (tableContents.length) {
          for (let i = 0; i < tableContents.length; i++) {
            tableContents[i].style.paddingRight = 200 + 'px';
          }
        }

        elements[length - 1].childNodes[0].innerHTML = `<div style='height: ${height}px;'></div>`;

        // 设置fixed-left时，子表格paddingRight为0
        const fixedTableLeft = document.querySelectorAll('.ant-table-fixed-left');
        if (fixedTableLeft.length) {
          const fixedRows = fixedTableLeft[0].querySelectorAll(`[data-row-key='${rec.id}-extra-row']`);
          if (fixedRows.length) {
            const fixedRowsSecondTd = fixedRows[0].querySelectorAll('td')[1];
            if (fixedRowsSecondTd) {
              fixedRowsSecondTd.style.paddingRight = 0;
            }
          }
        }
      }, 0);
    },
    showOpenSubTable (row, i, parenti) {
      let logisticsList = this.dataList[parenti].logisticsList;
      logisticsList[i].show = !logisticsList[i].show;
      logisticsList = JSON.parse(JSON.stringify(logisticsList));
      this.$set(this.dataList[parenti], 'logisticsList', logisticsList);
      setTimeout(() => {
        this.expandedOneRow('', this.dataList[parenti], 18.6);
      }, 0);
    },
    getList (type) {
      this.dataList = [];
      if (type === 'init') {
        this.total = 0;
        this.pagination = {
          pageNum: 1,
          pageSize: 10,
        };
      }

      let { pageSize, pageNum } = this.pagination;
      let orderBy = [
        {
          orderByProperty: 'lastUpdateTime',
          orderByType: 'DESC',
        },
      ];

      afterQueryPage({
        ...this.advancedForm,
        findRefundGoodsFlag: true,
        findLogisticsFlag: true,
        orderBy,
        pageSize,
        pageNum,
        types: [1, 3],
        listType: 2,
      }).then(({ body }) => {
        this.dataList = body.list.map(item => {
          (item.logisticsList || []).map(item2 => {
            item2.goodsSerialDetailList = [];
            item2.totalQuantity = 0;
            item2.totalPrice = 0;
            (item2.logisticsGoodsList || []).map(item3 => {
              item2.totalQuantity = item2.totalQuantity + item3.quantity;
              item2.totalPrice = item2.totalPrice + item3.quantity * item3.taxPrice;
              (item3.logisticsGoodsSerialList || []).map(item4 => {
                item2.goodsSerialDetailList.push({
                  ...item3,
                  ...item4,
                });
              });
              return item3;
            });
            return item2;
          });
          return item;
        });
        this.total = +body.total || 0;
        setTimeout(() => {
          this.expandedRowKeys = [];
          this.$refs.xzTable.addElementsToClass();
        }, 0);
      });
    },
    getCount () {
      queryStateInfoBySeller({
        listType: 2,
      }).then(({ body }) => {
        for (let v of this.executionStatusGroup) {
          v.count = body[v.en];
        }
        this.executionStatusGroup[0].count = body.waitReceiveCount + body.partReceiveCount + body.allReceiveCount;
      });
    },
    handleReset () {
      for (let key in this.advancedForm) {
        this.advancedForm[key] = '';
      }

      this.total = 0;
      this.pagination = {
        pageNum: 1,
        pageSize: 10,
      };

      this.getList('init');
    },
    operate (type, row) {
      if (type === 'confirm') {
        this.$confirm('是否确认对该售后进行收货？', '确认收货', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          sure({ id: row.outRefundId2 }).then(() => {
            this.$message({
              type: 'success',
              message: '收货成功!',
            });

            this.getList('init');
          });
        });
      } else {
        this.$router.push({
          path: '/afterSaleManagement/service/returnDetail',
          query: {
            id: row.outRefundId2,
          },
        });
      }
    },
    handleShowExpressDialog (logostics) {
      this.$refs.expressDialogRef.transportCode = logostics.code;
      this.$refs.expressDialogRef.info = logostics;
      this.$refs.expressDialogRef.dialogVisible = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.receive-returns {
  /deep/ .ant-table-body-inner {
    padding-bottom: 8px;
  }
}
@mixin tag_round() {
  padding: 4px 8px;
  border-radius: 4px;
}
.list-wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
  .content-wrapper {
    flex: 1;
    overflow: hidden;
    padding: 0 0 8px;

    .h-full {
      height: 100%;
      background-color: #fff;
      display: flex;
      flex-direction: column;

      .c_group {
        position: relative;

        .content_block {
          border-bottom: 0.5px solid #DFE2E8;
          padding: 10px;
        }

        .title {
          font-size: 14px;
          font-weight: 600;
          padding-right: 2em;
        }
      }

      .table-wrapper {
        padding: 16px 12px;
        flex: 1;
        overflow: auto;
        .xz-table-wrapper {
          height: 100%;

          .editable {
            /deep/ .ant-form-item {
              margin: 0;

              .ant-form-explain {
                display: none;
              }
            }

            /deep/ .ant-table-tbody > tr > td {
              padding: 0 16px 0;
              overflow-wrap: break-word;
            }
          }

          /deep/ .ant-table-thead {
            & > tr > th {
              padding: 9px 16px;
              font-weight: bold;
              background-color: #f2f4f7;
            }
          }

          /deep/ .ant-table-tbody {
            tr {
              background-color: #fff;

              & > td {
                padding: 9px 16px;
                border-bottom-color: #ebedf0;
              }
            }
          }

          /deep/ .ant-table-fixed-right {
            .ant-table-body-outer {
              padding-right: 0 !important;
            }

            .ant-table-thead {
              & > tr > th {
                padding: 9px 16px;
                font-weight: bold;
              }
            }

            .ant-table-tbody {
              tr {
                background-color: #fff;

                & > td {
                  padding: 9px 16px;
                  border-bottom-color: #ebedf0;
                }
              }
            }
          }
        }

        .ant-radio-button-wrapper {
          border-width: 0;
          background-color: #f2f4f7;

          &.active-radio {
            border-color: #e2f3fe;
            background-color: #e2f3fe;
            color: #237ffa;
          }
        }

        .ant-radio-button-wrapper:not(:first-child)::before {
          width: 0;
        }
      }
      .logostics-box {
        padding-top: 5px;
        padding-bottom: 15px;
        display: flex;
        .icon {
          width: 16px;
          height: 16px;
          margin-right: 8px;
          cursor: default;
        }
        .company {
          font-weight: 600;
          font-size: 14px;
          color: #1F2733;
          width: 250px;
          cursor: default;
        }
        .info {
          font-weight: 400;
          font-size: 14px;
          color: #929AA6;
          width: 300px;
          .value {
            font-weight: 400;
            font-size: 14px;
            color: #1F2733;
            margin-left: 12px;
          }
        }
      }
    }
  }
  .table-wrapper.fullscreen {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0px;
    z-index: 100;
    background: #FFFFFF;
  }

  /deep/ .contract-option {
    color: #02a7f0;
    cursor: pointer;
    padding: 0 0.25em;
  }

  .el-range-editor--small.el-input__inner {
    width: 100%;
  }
}
/deep/.ant-table-body::-webkit-scrollbar {
  height: 12px;
  width: 12px;
}

/deep/ .ant-table-body::-webkit-scrollbar-thumb {
  border-radius: 8px;
  box-shadow: inset 0 0 5px #c9ced6;
  background: #c9ced6;
}

//鼠标移入样式
/deep/ .ant-table-body::-webkit-scrollbar-thumb:hover {
  background: #c9ced6;
}

/deep/.ant-drawer-body {
  padding: 16px;
}
</style>
